export default __webpack_public_path__ + "static/media/maskman.b261b281.png";